var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.activePanel
    ? _c(
        "a",
        {
          staticClass: "header-icon",
          attrs: {
            href: "#",
            title: _vm.titlePanel,
            "data-toggle": "tooltip-city",
          },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.togglePanel.apply(null, arguments)
            },
          },
        },
        [
          _c("i", { staticClass: "far fa-clock" }),
          _vm._v(" "),
          _vm.number > 0
            ? _c("span", { staticClass: "badge badge-icon" }, [
                _vm._v("\n        " + _vm._s(_vm.number) + "\n    "),
              ])
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }